import backofficeService from '../../api/backoffice'

export default {
  /**
   * Get list of categories
   * @param {*} params
   * @param {*} params.limit
   * @param {*} params.offset
   * @param {*} params.search
   * @param {*} params.local Add LocalData to categories
   */
  getAll(params) {
    return backofficeService.Api().get('api/tickets/all', { params })
      .then(response => response.data)
      .catch((error) => { throw error })
  },
  searchInTicket(params = {}) {
    return backofficeService.Api().get('api/tickets/all', { params })
      .then(response => response.data)
      .catch((error) => { throw error })
  },
  getListOfUserDueTickets(id) {
    return backofficeService.Api().get(`api/getListOfUserDueTickets/${id}`)
      .then(response => response.data)
      .catch((error) => { throw error })
  },
  getAllTicketCount() {
    return backofficeService.Api().get('api/getAllTicketCount')
      .then(response => response.data)
      .catch((error) => { throw error })
  },
  getAllTicketbyUser() {
    return backofficeService.Api().get('api/getAllTicketbyUser')
      .then(response => response.data)
      .catch((error) => { throw error })
  },
  allUserDueTickets() {
    return backofficeService.Api().get('api/allUserDueTickets')
      .then(response => response.data)
      .catch((error) => { throw error })
  },
  getTicketFeedback() {
    return backofficeService.Api().get('api/ticket/feedback/byDate')
      .then(response => response.data)
      .catch((error) => { throw error })
  },
  /**
   * Get category by id
   * @param {*} params Query Options
   */
  getById(id, params) {
    return backofficeService.Api().get(`api/ticket/byId/${id}`, { params })
      .then(response => response.data)
      .catch((error) => { throw error })
  },
  getByStoreId(id, params) {
    return backofficeService.Api().get(`api/tickets/store/${id}`, { params })
      .then(response => response.data)
      .catch((error) => { throw error })
  },
  /**
   * Create a category. Will also initiate location data
   * @param {*} data
   */
  create(data) {
    return backofficeService.Api().post('api/ticket/create', data)
      .then(response => {
        console.log('response', response)
        return response.data
      })
      .catch((error) => { throw error })
  },
  /**
   * Update specific category
   * @param {*} id
   * @param {*} data
   */
  update(id, data) {
    return backofficeService.Api().put(`api/tickets/${id}`, data)
      .then(response => response.data)
      .catch((error) => { throw error })
  },
  /**
   * Delete category
   * @param {} id
   * @param {*} params
   */
  delete(id, params) {
    return backofficeService.Api().delete(`category/${id}`, { params })
      .then(response => response.data)
      .catch((error) => { throw error })
  },
}
